import { Box, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatNumberSpacing } from 'src/constants';

const RevenueCard = ({ icon, path, title, value, bgColor }) => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path?.to, { state: path?.status });
  };
  return (
    <Grid
      onClick={() => path?.to && handleNavigate(path)}
      className="card"
      item
      xs={5}
      md={2}
      sx={{
        height: '140px',
        bgcolor: bgColor,
        color: '#fff',
        minWidth: {
          sm: '250px',
          xs: '280px',
        },
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            minHeight: '50px',
            minWidth: '24%',
            borderRadius: '50%',
            bgcolor: '#fff',
            color: bgColor,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {icon}
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 500 }}>
          {t(`dashboard.${title}`)}
        </Typography>
      </Box>
      <Box sx={{ height: '110px', width: '100%', display: 'flex', alignItems: 'center', paddingLeft: '1rem' }}>
        <Typography variant="h4" sx={{ fontWeight: 500 }}>
          ${formatNumberSpacing(value)}
        </Typography>
      </Box>
    </Grid>
  );
};

export default RevenueCard;
